// GENERATED FILE, DO NOT MANUALLY EDIT
import { html } from '@horizon/base';
import { HznIconBase } from '../../icon/icon-base.js';
import './types.js';
/**
 *
 * @tag hzn-icon-lock-open
 * @tagname hzn-icon-lock-open
 * @summary An individual icon for Horizon
 */
export class HznIconLockOpen extends HznIconBase {
    render() {
        return html `<div class="hzn-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.74088 6.5C8.74088 5.39543 9.63631 4.5 10.7409 4.5C11.8454 4.5 12.7409 5.39543 12.7409 6.5V8.55513L5.38423 10.9369C4.33337 11.2771 3.75728 12.4048 4.0975 13.4557L6.56163 21.0667C6.90185 22.1176 8.02956 22.6937 9.08042 22.3535L18.5942 19.2733C19.6451 18.9331 20.2212 17.8054 19.881 16.7545L17.4168 9.14346C17.0766 8.0926 15.9489 7.51651 14.898 7.85673L14.7409 7.90762V6.5C14.7409 4.29086 12.95 2.5 10.7409 2.5C8.53174 2.5 6.74088 4.29086 6.74088 6.5V7.5C6.74088 8.05228 7.18859 8.5 7.74088 8.5C8.29316 8.5 8.74088 8.05228 8.74088 7.5V6.5ZM6.00026 12.8397L15.5141 9.7595L17.9782 17.3705L8.46439 20.4507L6.00026 12.8397Z" fill="currentColor"></path>
</svg></div>`;
    }
}
//# sourceMappingURL=lock-open.js.map